import React, { Component } from 'react'
import Security from '../../commons/security/Security.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import $ from 'jquery'
import moment from 'moment'
import 'moment/min/locales'
import {FormattedMessage, injectIntl} from 'react-intl';
import Timezone from '../../commons/timezone/Timezone.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import { formatCantidad } from '../../commons/utils/Helpers';
import ValidacionAutomaticaTooltip from '../presupuestoDetallado/ValidacionAutomaticaTooltip.jsx'
import MessageTooltip from '../ui/commons/tooltip/MessageTooltip.jsx'
import * as Utils from '../../commons/utils/Utils';
import backendStrings from '../../lang/backendStrings.js';
import Swal from 'sweetalert2';

// Estados de recotización parcial (VEC-3495): centralizados para tocar un solo lugar si cambian.
const PRESUPUESTO_ESTADO_RECHAZADO = 'Rechazado';
const TIPO_RECOTIZACION_PARCIAL = 'parcial';
const ITEM_ESTADO_RECOTIZACION_RECHAZADO = 'rechazado';

// Estilos para columnas de tabla de presupuesto
const presupuestoColStyle = {
	textAlign: 'left',
	paddingLeft: '8px',
	paddingRight: '8px',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	minWidth: '80px',
	maxWidth: '180px',
};

class TicketVerPresupuestosDetallado extends Component {
	constructor(props) {
		super(props);
		this.props = props;

		this.ajaxHandler = new AjaxHandler();

		moment.locale('es');

		if(props.ticket) {
			this.ticket = props.ticket;
		}
		this.action = props.action;

		this.state = {
			loading: false,
			presupuestos: [],
			indicesDetallesAbiertos: [],
			presupuestoPendiente: null,
			marcaObligatorio: true,
			mecanicosTareasExpandidos: {},
			diffsAbiertos: {},
			diffsDatos: {},
			diffsLoading: {}
		}

		this.toggleDiff = this.toggleDiff.bind(this);
		this.computarDiff = this.computarDiff.bind(this);
		this.renderDiffInline = this.renderDiffInline.bind(this);
    }

	formatMonto(numero) {
		// Redondear a 2 decimales
		const redondeado = Math.round(numero * 100) / 100;
		// Separar parte entera y decimal
		const partes = redondeado.toFixed(2).split('.');
		// Agregar separador de miles (punto)
		partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
		// Unir con coma como separador decimal
		return partes.join(',');
	}

  componentDidMount() {
		if(Security.hasPermission('TICKETS_VER_PRESUPUESTOS')) {
			this.ajaxHandler.subscribe(this);
			this.loadFormData();
		} else {
			this.setState({
			redirectTo: '/error'
			});
		}
  }

  componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
  }

  componentDidUpdate() {
		$('[data-tooltip="tooltip"]').tooltip();
  }

  loadFormData() {
		let component = this;
		component.setState({ loading: true });
		const marcaObligatorio = ConfigBusiness.get('inventario.marcas.obligatorio') === "false" ? false : true;
		component.setState({ marcaObligatorio });

		component.ajaxHandler.getJson('/ticket-presupuestos/ticket/' + this.props.ticket.id + '/grid')
		.then(data => {
			if(data){
				let index = data.findIndex((element) =>
					element.estado && (
						element.estado.toLowerCase().includes('pendiente') ||
						element.estado.toLowerCase().includes('validado-auditor')
					)
				);
				let presupuestoPendiente = index !== -1 ? data[index] : null;
				component.setState({presupuestos: data, presupuestoPendiente: presupuestoPendiente});
			}
		}).finally(() => {
			component.setState({ loading: false });
		});
  }

  handleViewAdjunto(e, adjunto) {
		this.ajaxHandler.fetch('/ticket-presupuestos/adjunto/' + adjunto, {
			method: 'GET'
		}).then(response => {
			if (response.status === 200) {
			return response.blob();
			}
		}).then(fileBlob => {
			let fileUrl = URL.createObjectURL(fileBlob);
			window.open(fileUrl);
		}).catch(() => {
		});
		e.preventDefault();
  }

	toggleMecanicosTarea(presupuestoIndex, tareaIndex) {
		var clave = presupuestoIndex + '-' + tareaIndex;
		var expandidos = Object.assign({}, this.state.mecanicosTareasExpandidos);
		expandidos[clave] = !expandidos[clave];
		this.setState({ mecanicosTareasExpandidos: expandidos });
	}

	viewDetalle(e, index){
		const indicesAbiertos = [...this.state.indicesDetallesAbiertos];
		const indexPosicion = indicesAbiertos.indexOf(index);

		if(indexPosicion !== -1){
			// Si ya está abierto, lo cerramos
			indicesAbiertos.splice(indexPosicion, 1);
		}else{
			// Si está cerrado, lo abrimos
			indicesAbiertos.push(index);
		}

		this.setState({indicesDetallesAbiertos: indicesAbiertos});
		e.preventDefault();
	}

    renderTableTheadTarea(field, index){
		switch (field) {
			case 'index':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Items" defaultMessage="Items" />
					</th>
				);
			case 'id':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Id" defaultMessage="Id" />
					</th>
				);
			case 'external_code':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Tarea" defaultMessage="Tarea" />
					</th>
				);
			case 'nombre':
				return (
					<th key={index} scope="col" style={presupuestoColStyle}>
						<FormattedMessage id="Presupuesto.Descripción" defaultMessage="Descripción" />
					</th>
				);
			case 'detalle':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Detalle" defaultMessage="Detalle" />
					</th>
				);
			case 'cuenta_mayor':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cuenta_Mayor" defaultMessage="Cuenta Mayor" />
					</th>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Descripción_Cuenta_Mayor" defaultMessage="Descripción Cuenta Mayor" />
					</th>
				);
			case 'cantidad':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cantidad" defaultMessage="Cantidad" />
					</th>
				);
			case 'precio':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Precio" defaultMessage="Precio" />
					</th>
				);
			case 'total':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Total" defaultMessage="Total" />
					</th>
				);
			case 'mecanico':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Mecanico" defaultMessage="Mecánico" />
					</th>
				);
			case 'servicio':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Servicio" defaultMessage="Servicio" />
					</th>
				);
			case 'garantia':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Garantía" defaultMessage="Garantía" />
					</th>
				);
			default:
				return null;
		}
	}

    renderTableTheadItem(field, index){
		switch (field) {
			case 'index':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Items" defaultMessage="Items" />
					</th>
				);
			case 'id':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Id" defaultMessage="Id" />
					</th>
				);
			case 'external_code':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Tarea" defaultMessage="Tarea" />
					</th>
				);
			case 'descripcion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle}>
						<FormattedMessage id="Presupuesto.Descripción" defaultMessage="Descripción" />
					</th>
				);
			case 'clasificacion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Clasificación" defaultMessage="Clasificación" />
					</th>
				);
			case 'detalle':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Detalle" defaultMessage="Detalle" />
					</th>
				);
			case 'cuenta_mayor':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cuenta_Mayor" defaultMessage="Cuenta Mayor" />
					</th>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Descripción_Cuenta_Mayor" defaultMessage="Descripción Cuenta Mayor" />
					</th>
				);
			case 'cantidad':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Cantidad" defaultMessage="Cantidad" />
					</th>
				);
			case 'costo':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Precio" defaultMessage="Precio" />
					</th>
				);
            case 'marcaNombre':
                return (
                    <th key={index} scope="col" style={presupuestoColStyle} >
                        <FormattedMessage id="Presupuesto.Marca" defaultMessage="Marca" />
                    </th>
                );
			case 'marca':
				return !this.state.marcaObligatorio ? (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Marca" defaultMessage="Marca" />
					</th>
				) : '';
			case 'total':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Total" defaultMessage="Total" />
					</th>
				);
			case 'mecanico':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Mecanico" defaultMessage="Mecánico" />
					</th>
				);
			case 'servicio':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Presupuesto.Servicio" defaultMessage="Servicio" />
					</th>
				);
			case 'garantia':
				return (
					<th key={index} scope="col" style={presupuestoColStyle} >
						<FormattedMessage id="Garantía" defaultMessage="Garantía" />
					</th>
				);
			default:
				return null;
		}
	}

	renderBadgeRechazoParcial(){
		return (
			<span className="badge badge-danger mr-2">
				<FormattedMessage id="ticketVerPresupuestos.rechazoParcial.badge" defaultMessage="Rechazado"/>
			</span>
		);
	}

    renderTableTbodyTarea(element, field, index, index_2, presupuestoIndex, esRechazadoParcial){
		var itemRechazado = esRechazadoParcial && element.estado_recotizacion === ITEM_ESTADO_RECOTIZACION_RECHAZADO;
		switch (field) {
			case 'index':
				return (
					<td key={index} className="all custom-lineHeight">
						{(index_2 ? index_2 : index) + 1}
					</td>
				);
			case 'id':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.id_tarea}
					</td>
				);
			case 'external_code':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.external_code}
					</td>
				);
			case 'nombre':
				return (
					<td key={index} className="all custom-lineHeight">
						{itemRechazado ? this.renderBadgeRechazoParcial() : null}
						{element.nombre}
						{itemRechazado && element.comentario_rechazo ? <MessageTooltip message={element.comentario_rechazo} color="danger" /> : null}
					</td>
				);
			case 'detalle':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.detalle}
					</td>
				);
			case 'cuenta_mayor':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor}
					</td>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor_descripcion}
					</td>
				);
			case 'cantidad':
				return (
					<td key={index} className="all custom-lineHeight">
						{formatCantidad(element.cantidad)}
					</td>
				);
			case 'precio':
				return (
					<td key={index} className="all custom-lineHeight">
						{this.formatMonto(element.precio)}
					</td>
				);
			case 'mecanico': {
				var mecanicos = element.mecanicos || [];
				if (mecanicos.length === 0) {
					return <td key={index} className="all custom-lineHeight"></td>;
				}
				if (mecanicos.length === 1) {
					return (
						<td key={index} className="all custom-lineHeight">
							{mecanicos[0].nombre + ' ' + mecanicos[0].apellido}
						</td>
					);
				}
				var clave = presupuestoIndex + '-' + index;
				var expandido = this.state.mecanicosTareasExpandidos[clave] || false;
				return (
					<td key={index} className="all custom-lineHeight">
						<span>{mecanicos[0].nombre + ' ' + mecanicos[0].apellido}</span>
						<button
							className="btn btn-link btn-sm p-0 ml-1"
							style={{verticalAlign: 'baseline'}}
							onClick={() => this.toggleMecanicosTarea(presupuestoIndex, index)}
						>
							<i className={expandido ? 'fa fa-chevron-up fa-xs' : 'fa fa-chevron-down fa-xs'}></i>
							{' +' + (mecanicos.length - 1)}
						</button>
						{expandido && (
							<ul className="list-unstyled mb-0 mt-1" style={{fontSize: '0.9em'}}>
								{mecanicos.slice(1).map(function(m, i) {
									return <li key={i}>{m.nombre + ' ' + m.apellido}</li>;
								})}
							</ul>
						)}
					</td>
				);
			}
			case 'total':
				return (
					<td key={index} className="all custom-lineHeight">
                        {element.precio && element.cantidad ? ('$ ' + this.formatMonto(element.precio*element.cantidad)) : ''}
					</td>
				);
			case 'servicio':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.servicio_nombre}
						<ValidacionAutomaticaTooltip element={element} intl={this.props.intl} />
					</td>
				);
			case 'garantia':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.garantia ? (
							<span className="badge badge-warning" style={{display: 'inline-flex', alignItems: 'center'}}>
								<FormattedMessage id="Garantía" defaultMessage="Garantía" />
								{element.garantia_ticket_id ? (
									<span> - <a href={'/tickets/' + element.garantia_ticket_id} target="_blank" rel="noopener noreferrer">{'Ticket #' + element.garantia_ticket_id}</a></span>
								) : null}
							</span>
						) : null}
					</td>
				);
			default:
				return null;
		}
	}

    renderTableTbodyItem(element, field, index, index_2, presupuestoIndex, esRechazadoParcial){
		var itemRechazado = esRechazadoParcial && element.estado_recotizacion === ITEM_ESTADO_RECOTIZACION_RECHAZADO;
		switch (field) {
			case 'index':
				return (
					<td key={index} className="all custom-lineHeight">
						{(index_2 ? index_2 : index) + 1}
					</td>
				);
			case 'id':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.id_item}
					</td>
				);
			case 'external_code':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.external_code}
					</td>
				);
			case 'descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{itemRechazado ? this.renderBadgeRechazoParcial() : null}
						{element.descripcion}
						{itemRechazado && element.comentario_rechazo ? <MessageTooltip message={element.comentario_rechazo} color="danger" /> : null}
					</td>
				);
			case 'clasificacion':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.clasificacion || ''}
					</td>
				);
			case 'detalle':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.detalle}
					</td>
				);
			case 'cuenta_mayor':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor}
					</td>
				);
			case 'cuenta_mayor_descripcion':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.cuenta_mayor_descripcion}
					</td>
				);
			case 'cantidad':
				return (
					<td key={index} className="all custom-lineHeight">
						{formatCantidad(element.cantidad)}
					</td>
				);
			case 'costo':
				return (
					<td key={index} className="all custom-lineHeight">
						{this.formatMonto(element.precio)}
					</td>
				);
            case 'marcaNombre':
                return (
                    <td key={index} className="all custom-lineHeight">
                        {element.marcaNombre}
                    </td>
                );
			case 'marca':
				return !this.state.marcaObligatorio ? (
					<td key={index} className="all custom-lineHeight">
						{element.marca ? element.marca : ''}
					</td>
				) : '';
			case 'total':
				return (
					<td key={index} className="all custom-lineHeight">
                        {element.precio && element.cantidad ? ('$ ' + this.formatMonto(element.precio*element.cantidad)) : ''}
					</td>
				);
			case 'mecanico': {
				var mecanicosItem = element.mecanicos || [];
				if (mecanicosItem.length === 0) {
					return <td key={index} className="all custom-lineHeight"></td>;
				}
				if (mecanicosItem.length === 1) {
					return (
						<td key={index} className="all custom-lineHeight">
							{mecanicosItem[0].nombre + ' ' + mecanicosItem[0].apellido}
						</td>
					);
				}
				var claveItem = presupuestoIndex + '-item-' + index;
				var expandidoItem = this.state.mecanicosTareasExpandidos[claveItem] || false;
				return (
					<td key={index} className="all custom-lineHeight">
						<span>{mecanicosItem[0].nombre + ' ' + mecanicosItem[0].apellido}</span>
						<button
							className="btn btn-link btn-sm p-0 ml-1"
							style={{verticalAlign: 'baseline'}}
							onClick={() => this.toggleMecanicosTarea(presupuestoIndex + '-item', index)}
						>
							<i className={expandidoItem ? 'fa fa-chevron-up fa-xs' : 'fa fa-chevron-down fa-xs'}></i>
							{' +' + (mecanicosItem.length - 1)}
						</button>
						{expandidoItem && (
							<ul className="list-unstyled mb-0 mt-1" style={{fontSize: '0.9em'}}>
								{mecanicosItem.slice(1).map(function(m, i) {
									return <li key={i}>{m.nombre + ' ' + m.apellido}</li>;
								})}
							</ul>
						)}
					</td>
				);
			}
			case 'servicio':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.servicio_nombre}
						<ValidacionAutomaticaTooltip element={element} intl={this.props.intl} />
					</td>
				);
			case 'garantia':
				return (
					<td key={index} className="all custom-lineHeight">
						{element.garantia ? (
							<span className="badge badge-warning" style={{display: 'inline-flex', alignItems: 'center'}}>
								<FormattedMessage id="Garantía" defaultMessage="Garantía" />
								{element.garantia_ticket_id ? (
									<span> - <a href={'/tickets/' + element.garantia_ticket_id} target="_blank" rel="noopener noreferrer">{'Ticket #' + element.garantia_ticket_id}</a></span>
								) : null}
							</span>
						) : null}
					</td>
				);
			default:
				return null;
		}
	}

	computarDiff(anterior, sucesor) {
		var anteriorItems = (anterior && anterior.items) ? anterior.items : [];
		var sucesorItems = (sucesor && sucesor.items) ? sucesor.items : [];
		var anteriorTareas = (anterior && anterior.tareas) ? anterior.tareas : [];
		var sucesorTareas = (sucesor && sucesor.tareas) ? sucesor.tareas : [];

		function itemKey(el) {
			return el.id_item
				? String(el.id_item) + '-' + String(el.servicio_id)
				: String(el.descripcion) + '-' + String(el.servicio_id);
		}

		function tareaKey(el) {
			return el.id_tarea
				? String(el.id_tarea) + '-' + String(el.servicio_id)
				: String(el.descripcion) + '-' + String(el.servicio_id);
		}

		function computarCambios(ant, suc) {
			var cambios = [];
			if (String(ant.cantidad) !== String(suc.cantidad)) {
				cambios.push({ campo: 'cantidad', anterior: ant.cantidad, nuevo: suc.cantidad });
			}
			var antPrecio = ant.precio !== null && ant.precio !== undefined ? parseFloat(ant.precio) : null;
			var sucPrecio = suc.precio !== null && suc.precio !== undefined ? parseFloat(suc.precio) : null;
			var antPrecioR = antPrecio !== null ? Math.round(antPrecio * 100) / 100 : null;
			var sucPrecioR = sucPrecio !== null ? Math.round(sucPrecio * 100) / 100 : null;
			if (antPrecioR !== sucPrecioR) {
				cambios.push({ campo: 'precio', anterior: ant.precio, nuevo: suc.precio });
			}
			if (String(ant.descripcion || '') !== String(suc.descripcion || '')) {
				cambios.push({ campo: 'descripcion', anterior: ant.descripcion, nuevo: suc.descripcion });
			}
			var antMecanicos = (ant.mecanicos || []).map(function(m) { return m.id; }).sort().join(',');
			var sucMecanicos = (suc.mecanicos || []).map(function(m) { return m.id; }).sort().join(',');
			if (antMecanicos !== sucMecanicos) {
				cambios.push({ campo: 'mecanico', anterior: ant.mecanicos || [], nuevo: suc.mecanicos || [] });
			}
			return cambios;
		}

		function procesarLista(anteriorLista, sucesorLista, keyFn) {
			// Lookup con consumo (1-a-1) sobre lista mutable.
			// Evita el bug N-a-1 cuando dos entradas del sucesor comparten la misma key
			// (ej: hereda 1× "rueda" + el proveedor agrega otra "rueda" desde el selector).
			var anteriorRemaining = anteriorLista.slice();
			var resultado = [];

			sucesorLista.forEach(function(suc) {
				// Si el sucesor trae estado_recotizacion='nuevo' explícito, cortocircuitar:
				// es una entrada agregada en esta sesión de recotización, no debe consumir un anterior.
				if (suc.estado_recotizacion === 'nuevo') {
					resultado.push({ presente: 'solo_sucesor', anterior: null, sucesor: suc, tipo: 'nuevo', cambios: [] });
					return;
				}
				var key = keyFn(suc);
				var idx = -1;
				for (var i = 0; i < anteriorRemaining.length; i++) {
					if (keyFn(anteriorRemaining[i]) === key) { idx = i; break; }
				}
				if (idx === -1) {
					// sin match disponible → nuevo
					resultado.push({ presente: 'solo_sucesor', anterior: null, sucesor: suc, tipo: 'nuevo', cambios: [] });
				} else {
					var ant = anteriorRemaining[idx];
					anteriorRemaining.splice(idx, 1); // consume el anterior
					var cambios = computarCambios(ant, suc);
					resultado.push({
						presente: 'ambos',
						anterior: ant,
						sucesor: suc,
						tipo: cambios.length > 0 ? 'modificado' : 'sin_cambios',
						cambios: cambios
					});
				}
			});

			// Lo que queda en anteriorRemaining nunca matcheó → eliminado
			anteriorRemaining.forEach(function(ant) {
				resultado.push({ presente: 'solo_anterior', anterior: ant, sucesor: null, tipo: 'eliminado', cambios: [] });
			});

			return resultado;
		}

		var itemsDiff = procesarLista(anteriorItems, sucesorItems, itemKey);
		var tareasDiff = procesarLista(anteriorTareas, sucesorTareas, tareaKey);

		return { itemsDiff: itemsDiff, tareasDiff: tareasDiff };
	}

	toggleDiff(idPresupuestoAnterior, idPresupuestoSucesor) {
		// Estado y caché se indexan por idPresupuestoSucesor: el botón
		// "Ver diff" vive en la fila del sucesor, así que el expand y el
		// toggle abren/cierran tomando la identidad de esa fila.
		var component = this;
		var diffsAbiertos = Object.assign({}, this.state.diffsAbiertos);

		if (diffsAbiertos[idPresupuestoSucesor]) {
			diffsAbiertos[idPresupuestoSucesor] = false;
			component.setState({ diffsAbiertos: diffsAbiertos });
			return;
		}

		var diffsDatos = component.state.diffsDatos;
		if (diffsDatos[idPresupuestoSucesor]) {
			diffsAbiertos[idPresupuestoSucesor] = true;
			component.setState({ diffsAbiertos: diffsAbiertos });
			return;
		}

		var diffsLoading = Object.assign({}, component.state.diffsLoading);
		diffsLoading[idPresupuestoSucesor] = true;
		component.setState({ diffsLoading: diffsLoading });

		// VEC-3203: el endpoint puede devolver el shape `{mensaje, context}` para errores 400.
		// `skipErrorHandling: true` evita que Utils.getData dispare el modal legacy con
		// "Error" vacío (porque su rama 400 lee `detalle`, que no viene). Traducimos
		// nosotros mismos vía Utils.translateBackendKey.
		Utils.getData(
			'/ticket-presupuestos/diff/' + idPresupuestoAnterior + '/' + idPresupuestoSucesor,
			{ skipErrorHandling: true }
		)
			.then(function(envelope) {
				var data = envelope && envelope.data ? envelope.data : null;
				if (data) {
					var cambios = component.computarDiff(data.anterior, data.sucesor);
					var newDiffsDatos = Object.assign({}, component.state.diffsDatos);
					newDiffsDatos[idPresupuestoSucesor] = {
						anterior: data.anterior,
						sucesor: data.sucesor,
						cambios: cambios
					};
					var newDiffsAbiertos = Object.assign({}, component.state.diffsAbiertos);
					newDiffsAbiertos[idPresupuestoSucesor] = true;
					var newDiffsLoading = Object.assign({}, component.state.diffsLoading);
					newDiffsLoading[idPresupuestoSucesor] = false;
					component.setState({
						diffsDatos: newDiffsDatos,
						diffsAbiertos: newDiffsAbiertos,
						diffsLoading: newDiffsLoading
					});
				}
			})
			.catch(function(err) {
				var newDiffsLoading = Object.assign({}, component.state.diffsLoading);
				newDiffsLoading[idPresupuestoSucesor] = false;
				component.setState({ diffsLoading: newDiffsLoading });

				var status = err && err.response ? err.response.status : null;
				var data = err && err.response && err.response.data ? err.response.data : null;
				var intl = component.props.intl;
				// VEC-3203 shape: { mensaje: <i18n-key>, context: {...} }
				if (status === 400 && data && data.mensaje && backendStrings[data.mensaje]) {
					var mensajeTraducido = Utils.translateBackendKey(data.mensaje, data.context, intl);
					Swal.fire({
						title: intl.formatMessage({ id: 'common.error', defaultMessage: 'Error' }),
						text: mensajeTraducido,
						type: 'error',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-primary',
						confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' })
					});
				} else if (data && data.mensaje) {
					// Backend devolvió `mensaje` pero la key no está en backendStrings:
					// mostrar la key cruda (fallback histórico de translateBackendKey).
					Swal.fire({
						title: intl.formatMessage({ id: 'common.error', defaultMessage: 'Error' }),
						text: data.mensaje,
						type: 'error',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-primary',
						confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' })
					});
				} else {
					// Fallback genérico para errores de red / 5xx (paridad con el modal que
					// dispararía handleError si no hubiéramos pasado skipErrorHandling).
					Swal.fire({
						title: intl.formatMessage({ id: 'common.error', defaultMessage: 'Error' }),
						text: intl.formatMessage({ id: 'errors.default', defaultMessage: 'Ocurrió un error inesperado. Intente nuevamente.' }),
						type: 'error',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-primary',
						confirmButtonText: intl.formatMessage({ id: 'Aceptar', defaultMessage: 'Aceptar' })
					});
				}
			});
	}

	renderDiffInline(presupuesto, colSpanTotal, trabajaConManoDeObra) {
		var id = presupuesto.id;
		var diffDatos = this.state.diffsDatos[id];
		var isLoading = this.state.diffsLoading[id];
		var intl = this.props.intl;

		var DIFF_COLORES = {
			nuevo: '#d4edda',
			modificado: '#fff3cd',
			eliminado: '#f8d7da',
			sin_cambios: 'transparent'
		};

		if (isLoading) {
			return (
				<tr style={{ background: '#eaecef' }}>
					<td colSpan={colSpanTotal}>
						<div className="p-3 text-center text-muted">
							<i className="fa fa-spinner fa-spin mr-2"></i>
							<FormattedMessage id="ticketVerPresupuestos.diff.loading" defaultMessage="Cargando comparación..." />
						</div>
					</td>
				</tr>
			);
		}

		if (!diffDatos) {
			return (
				<tr style={{ background: '#eaecef' }}>
					<td colSpan={colSpanTotal}>
						<div className="p-3 text-center text-danger">
							<FormattedMessage id="ticketVerPresupuestos.diff.error" defaultMessage="Error al cargar la comparación" />
						</div>
					</td>
				</tr>
			);
		}

		var itemsDiff = diffDatos.cambios.itemsDiff;
		var tareasDiff = diffDatos.cambios.tareasDiff;

		var moDiff = trabajaConManoDeObra
			? itemsDiff.filter(function(d) {
				var obj = d.sucesor || d.anterior;
				return obj && obj.tipo === 'Mano De Obra';
			})
			: tareasDiff;

		var repuestosDiff = trabajaConManoDeObra
			? itemsDiff.filter(function(d) {
				var obj = d.sucesor || d.anterior;
				return !obj || obj.tipo !== 'Mano De Obra';
			})
			: itemsDiff;

		var renderBadge = function(tipo) {
			if (tipo === 'nuevo') {
				return <span className="badge badge-success mr-2"><FormattedMessage id="ticketVerPresupuestos.diff.badge.nuevo" defaultMessage="Nuevo" /></span>;
			}
			if (tipo === 'modificado') {
				return <span className="badge badge-warning mr-2"><FormattedMessage id="ticketVerPresupuestos.diff.badge.modificado" defaultMessage="Modificado" /></span>;
			}
			if (tipo === 'eliminado') {
				return <span className="badge badge-danger mr-2"><FormattedMessage id="ticketVerPresupuestos.diff.badge.eliminado" defaultMessage="Eliminado" /></span>;
			}
			return null;
		};
		var renderDiffTabla = function(titulo, filas, showMecanico) {
			if (filas.length === 0) return null;
			return (
				<div className="col-md-12 mb-3">
					<h5 className="p-2" style={{ color: '#44c8cf' }}><b>{titulo}</b></h5>
					<table className="table table-sm" style={{ fontSize: '13px' }}>
						<thead className="thead-fleet">
							<tr>
								<th><FormattedMessage id="Presupuesto.Descripción" defaultMessage="Descripción" /></th>
								<th><FormattedMessage id="Presupuesto.Servicio" defaultMessage="Servicio" /></th>
								<th><FormattedMessage id="Presupuesto.Cantidad" defaultMessage="Cantidad" /></th>
								<th><FormattedMessage id="Presupuesto.Precio" defaultMessage="Precio" /></th>
								{showMecanico && <th><FormattedMessage id="Presupuesto.Mecanico" defaultMessage="Mecánico" /></th>}
							</tr>
						</thead>
						<tbody>
							{filas.map(function(d, idx) {
								var obj = d.sucesor || d.anterior;
								var descripcion = obj ? obj.descripcion : '';
								var servicioNombre = obj && obj.servicio && obj.servicio.nombre ? obj.servicio.nombre : '';
								var bgColor = DIFF_COLORES[d.tipo] || 'transparent';

								var cantidadAnt = d.anterior ? d.anterior.cantidad : null;
								var cantidadSuc = d.sucesor ? d.sucesor.cantidad : null;
								var precioAnt = d.anterior ? d.anterior.precio : null;
								var precioSuc = d.sucesor ? d.sucesor.precio : null;

								var hasCantCambio = d.cambios && d.cambios.some(function(c) { return c.campo === 'cantidad'; });
								var hasPrecioCambio = d.cambios && d.cambios.some(function(c) { return c.campo === 'precio'; });
								var hasDescCambio = d.cambios && d.cambios.some(function(c) { return c.campo === 'descripcion'; });

								var descDisplay;
								if (d.tipo === 'nuevo') {
									descDisplay = <span style={{ color: '#155724' }}>{descripcion}</span>;
								} else if (d.tipo === 'eliminado') {
									descDisplay = <s style={{ color: '#721c24' }}>{descripcion}</s>;
								} else if (d.tipo === 'modificado' && hasDescCambio) {
									var descCambio = d.cambios.find(function(c) { return c.campo === 'descripcion'; });
									descDisplay = (
										<span>
											<s style={{ color: '#856404', marginRight: '4px' }}>{descCambio.anterior}</s>
											<span style={{ color: '#155724' }}>{descCambio.nuevo}</span>
										</span>
									);
								} else {
									descDisplay = <span>{descripcion}</span>;
								}

								var cantDisplay;
								if (d.tipo === 'nuevo') {
									cantDisplay = <span style={{ color: '#155724' }}>{cantidadSuc}</span>;
								} else if (d.tipo === 'eliminado') {
									cantDisplay = <s style={{ color: '#721c24' }}>{cantidadAnt}</s>;
								} else if (d.tipo === 'modificado' && hasCantCambio) {
									var cantCambio = d.cambios.find(function(c) { return c.campo === 'cantidad'; });
									cantDisplay = (
										<span>
											<s style={{ color: '#856404', marginRight: '4px' }}>{cantCambio.anterior}</s>
											<span style={{ color: '#155724' }}>{cantCambio.nuevo}</span>
										</span>
									);
								} else {
									cantDisplay = <span>{d.sucesor ? d.sucesor.cantidad : (d.anterior ? d.anterior.cantidad : '')}</span>;
								}

								var precioDisplay;
								if (d.tipo === 'nuevo') {
									precioDisplay = <span style={{ color: '#155724' }}>{precioSuc !== null && precioSuc !== undefined ? parseFloat(precioSuc).toFixed(2) : ''}</span>;
								} else if (d.tipo === 'eliminado') {
									precioDisplay = <s style={{ color: '#721c24' }}>{precioAnt !== null && precioAnt !== undefined ? parseFloat(precioAnt).toFixed(2) : ''}</s>;
								} else if (d.tipo === 'modificado' && hasPrecioCambio) {
									var precioCambio = d.cambios.find(function(c) { return c.campo === 'precio'; });
									precioDisplay = (
										<span>
											<s style={{ color: '#856404', marginRight: '4px' }}>{precioCambio.anterior !== null && precioCambio.anterior !== undefined ? parseFloat(precioCambio.anterior).toFixed(2) : ''}</s>
											<span style={{ color: '#155724' }}>{precioCambio.nuevo !== null && precioCambio.nuevo !== undefined ? parseFloat(precioCambio.nuevo).toFixed(2) : ''}</span>
										</span>
									);
								} else {
									var precioVal = d.sucesor ? d.sucesor.precio : (d.anterior ? d.anterior.precio : '');
									precioDisplay = <span>{precioVal !== null && precioVal !== undefined ? parseFloat(precioVal).toFixed(2) : ''}</span>;
								}

								var servicioDisplay;
								if (d.tipo === 'nuevo') {
									servicioDisplay = <span style={{ color: '#155724' }}>{servicioNombre}</span>;
								} else if (d.tipo === 'eliminado') {
									servicioDisplay = <s style={{ color: '#721c24' }}>{servicioNombre}</s>;
								} else {
									servicioDisplay = <span>{servicioNombre}</span>;
								}

								var mecanicoDisplay = null;
								if (showMecanico) {
									var hasMecanicoCambio = d.cambios && d.cambios.some(function(c) { return c.campo === 'mecanico'; });
									var mecanicoCambio = hasMecanicoCambio ? d.cambios.find(function(c) { return c.campo === 'mecanico'; }) : null;
									var mecanicosAnt = mecanicoCambio ? mecanicoCambio.anterior : (d.anterior && d.anterior.mecanicos || []);
									var mecanicosSuc = mecanicoCambio ? mecanicoCambio.nuevo : (d.sucesor && d.sucesor.mecanicos || []);
									var nombresAnt = mecanicosAnt.map(function(m) { return m.label || (m.nombre + ' ' + m.apellido); }).join(', ') || '-';
									var nombresSuc = mecanicosSuc.map(function(m) { return m.label || (m.nombre + ' ' + m.apellido); }).join(', ') || '-';
									if (d.tipo === 'nuevo') {
										mecanicoDisplay = <span style={{ color: '#155724' }}>{nombresSuc}</span>;
									} else if (d.tipo === 'eliminado') {
										mecanicoDisplay = <s style={{ color: '#721c24' }}>{nombresAnt}</s>;
									} else if (d.tipo === 'modificado' && hasMecanicoCambio) {
										mecanicoDisplay = (
											<span>
												<s style={{ color: '#856404', marginRight: '4px' }}>{nombresAnt}</s>
												<span style={{ color: '#155724' }}>{nombresSuc}</span>
											</span>
										);
									} else {
										mecanicoDisplay = <span>{nombresSuc}</span>;
									}
								}

								return (
									<tr key={idx} style={{ backgroundColor: bgColor }}>
										<td className="align-middle">
											{renderBadge(d.tipo)}
											{descDisplay}
										</td>
										<td className="align-middle">{servicioDisplay}</td>
										<td className="align-middle">{cantDisplay}</td>
										<td className="align-middle">{precioDisplay}</td>
										{showMecanico && <td className="align-middle">{mecanicoDisplay}</td>}
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
			);
		};

		var tituloMO = intl.formatMessage({ id: 'ticketVerPresupuestos.diff.mano_de_obra', defaultMessage: 'Mano de Obra' });
		var tituloRepuestos = intl.formatMessage({ id: 'ticketVerPresupuestos.diff.repuestos', defaultMessage: 'Repuestos' });

		return (
			<tr style={{ background: '#eaecef' }}>
				<td colSpan={colSpanTotal}>
					<div className="p-2">
						<h5 className="p-1 mb-3" style={{ color: '#555', borderBottom: '1px solid #ccc' }}>
							<i className="la la-history mr-2"></i>
							<FormattedMessage id="ticketVerPresupuestos.diff.section_title" defaultMessage="Comparación con el presupuesto rechazado anterior" />
						</h5>
						<div className="col-md-12">
							{renderDiffTabla(tituloMO, moDiff, true)}
							{renderDiffTabla(tituloRepuestos, repuestosDiff, false)}
							{moDiff.length === 0 && repuestosDiff.length === 0 && (
								<div className="text-center text-muted p-3">
									<FormattedMessage id="ticketVerPresupuestos.diff.sin_cambios" defaultMessage="Sin cambios" />
								</div>
							)}
						</div>
					</div>
				</td>
			</tr>
		);
	}

	render() {
        let showItems = ConfigBusiness.get('tickets.presupuesto.items.show').split(',');
		let showTareas = ConfigBusiness.get('tickets.presupuesto.tareas.show').split(',');
		let trabajaConManoDeObra = ConfigBusiness.get('tickets.trabajaConManoDeObra.habilitado') === 'true';
		if (ConfigBusiness.get('tickets.periodoGarantia.habilitado') === 'true') {
			showItems = showItems.concat(['garantia']);
			showTareas = showTareas.concat(['garantia']);
		}
		var showItemsSinMecanico = showItems.filter(function(f) { return f !== 'mecanico'; });
		if(this.props.ticket) {
			return (
			<React.Fragment>
				{this.state.loading && <Loading />}
				<div className="row-12">
					{this.state.presupuestos ? (
					<>
						<div className="row pt-4 justify-content-center">
							<div className="col-12 col-md-5">
								<div className="card text-dark" style={{borderLeftWidth: "0px", background: "#eaecef", height: "100%"}}>
									<div className="card-body">
										<div className="text-center">
											<h5 className="card-title mb-3">
												<FormattedMessage id="Presupuesto.Presupuestos_aprobados" defaultMessage="Presupuestos aprobados"/>
											</h5>
											<p className="card-text" style={{fontSize: "32px", color: "#44c8cf"}}>
												<b>${this.formatMonto(this.state.presupuestos
													.filter(presupuesto => presupuesto.estado && presupuesto.estado.toLowerCase().includes('aprobado') && presupuesto.activo === true)
													.reduce((total, presupuesto) => {
														return total + (presupuesto.manoDeObra || 0) + (presupuesto.repuestos || 0) + (presupuesto.impuestos || 0) + (presupuesto.otros || 0);
													}, 0))}</b>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-5">
								<div className="card text-dark" style={{borderLeftWidth: "0px", background: "#eaecef", height: "100%"}}>
									<div className="card-body">
										<div className="text-center">
											<h5 className="card-title mb-3">
												<FormattedMessage id="Presupuesto.Pendiente_de_aprobacion" defaultMessage="Pendiente de aprobación"/>
											</h5>
											<p className="card-text" style={{fontSize: "32px", color: "#ffa726"}}>
												<b>${this.state.presupuestoPendiente ?
													this.formatMonto(this.state.presupuestoPendiente.manoDeObra + this.state.presupuestoPendiente.repuestos + this.state.presupuestoPendiente.impuestos + this.state.presupuestoPendiente.otros)
													: this.formatMonto(0)
												}</b>
											</p>
											{this.state.presupuestoPendiente && (
												<p className="card-text text-muted" style={{fontSize: "14px"}}>
													<FormattedMessage id="Presupuesto.Fecha" defaultMessage="Fecha"/>: <b>{Timezone.getDateForClient(this.state.presupuestoPendiente.fechaHora, 'YYYY-MM-DD HH:mm:ss', "DD/MM/YYYY HH:mm:ss")}</b>
												</p>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</> ): ''}
					<div className="row pt-5">
						<div className="col-md-12">
							<div className="col-md-12">
								<h2 className="p-2" style={{color: "#44c8cf"}}><b><FormattedMessage id="Historial_de_Presupuestos" defaultMessage="Historial de Presupuestos"/></b></h2>
								<table className="table">
									<thead className="thead-fleet">
										<tr>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Fecha" defaultMessage="Fecha"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Nombre" defaultMessage="Nombre"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Subido_por" defaultMessage="Subido por"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Mano_de_obra" defaultMessage="Mano de obra"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Repuestos" defaultMessage="Repuestos"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Impuestos" defaultMessage="Impuestos"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Otros" defaultMessage="Otros"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Total" defaultMessage="Total"/>
											</th>
											<th scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Adicional" defaultMessage="Adicional"/>
											</th>
											{
											ConfigBusiness.get('tickets.trabajaConEstadosPresupuesto.habilitado') === 'true' ?
												<th scope="col" style={presupuestoColStyle} ><FormattedMessage id="Estado" defaultMessage="Estado"/></th>
												: null
											}
											<th className="text-right" scope="col" style={presupuestoColStyle} >
												<FormattedMessage id="Acciones" defaultMessage="Acciones"/>
											</th>
										</tr>
									</thead>
									<tbody>
										{this.state.presupuestos.length > 0 ?
											this.state.presupuestos.map((presupuesto, index) => {
												var esRechazadoParcial = presupuesto.estado === PRESUPUESTO_ESTADO_RECHAZADO && presupuesto.tipoRecotizacion === TIPO_RECOTIZACION_PARCIAL;
												return (
													<React.Fragment key={index}>
														<tr>
															<td className="align-middle">
																{Timezone.getDateForClient(presupuesto.fechaHora, 'YYYY-MM-DD HH:mm:ss', "DD/MM/YYYY HH:mm:ss")}
															</td>
															<td className="align-middle">
																{presupuesto.nombre}
															</td>
															<td className="align-middle">
																{presupuesto.persona.nombre + ' '  + presupuesto.persona.apellido }
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.manoDeObra)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.repuestos)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.impuestos)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.otros)}
															</td>
															<td className="align-middle">
																{this.formatMonto(presupuesto.manoDeObra + presupuesto.repuestos + presupuesto.impuestos + presupuesto.otros)}
															</td>
															<td className="align-middle">
																{presupuesto.adicional? (<div className="text-center success dt-info-icon"><i className="ft-check"></i></div>) : ''}
															</td>
															{ConfigBusiness.get('tickets.trabajaConEstadosPresupuesto.habilitado') === 'true' ?
																<td className="align-middle">
																{
																	presupuesto.estado && (
																		<span className={
																			{
																				'Pendiente': 'pendiente',
																				'Pendiente-Auditor': 'pendiente',
																				'Validado-Auditor': 'pendiente',
																				'Rechazado': 'rechazado-presupuesto-color',
																				'Aprobado': 'aprobado-presupuesto-color',
																				'Auto-Aprobado': 'aprobado-presupuesto-color',
																			}[presupuesto.estado] || ''
																		}>
																			<FormattedMessage id={presupuesto.estado} defaultMessage={presupuesto.estado} />
																		</span>
																	)
																}
																</td>
															: null}
															<td className="text-right">
																<div className="d-inline-flex">
																	<button
																		className="action view btn btn-sm btn-icon btn-dt-grid text-fleet"
																		title={this.props.intl.formatMessage({ id: 'Ver', defaultMessage: 'Ver' })}
																		data-togle="tooltip"
																		data-placement="top"
																		onClick={(e) => this.viewDetalle(e, index)}
																	>
																		<i className="fa fa-eye fa-xs"/>
																	</button>
                                                                    {presupuesto.adjunto ?
                                                                        <button
                                                                            className="action btn btn-icon text-fleet btn-sm btn-dt-grid p-0 m-0"
                                                                            data-tooltip="tooltip"
                                                                            data-placement="top"
                                                                            title={this.props.intl.formatMessage({ id: 'Ver_Adjunto', defaultMessage: 'Ver Adjunto' })}
                                                                            onClick={(e) => this.handleViewAdjunto(e, presupuesto.adjunto)}
                                                                        >
                                                                            <i className="fa fa-paperclip fa-xs"></i>
                                                                        </button>
                                                                    : null}
																{(this.state.presupuestos[index + 1] && this.state.presupuestos[index + 1].estado === PRESUPUESTO_ESTADO_RECHAZADO && this.state.presupuestos[index + 1].tipoRecotizacion === TIPO_RECOTIZACION_PARCIAL) ? (
																	<button
																		type="button"
																		className="action btn btn-sm btn-icon btn-dt-grid text-fleet ml-1"
																		title={this.props.intl.formatMessage({ id: 'ticketVerPresupuestos.diff.button_title', defaultMessage: 'Ver cambios respecto al presupuesto rechazado anterior' })}
																		onClick={() => this.toggleDiff(this.state.presupuestos[index + 1].id, presupuesto.id)}
																	>
																		<i className="la la-history fa-xs"/>
																	</button>
																) : null}
																</div>
															</td>
														</tr>
														{
															this.state.indicesDetallesAbiertos.includes(index) ?
															<tr style={{background: "#eaecef"}}>
																<td colSpan="10">
																	<div className="p-2">
																		<div className="col-md-12">
																			<div className="col-md-12">
																				<h2 className="p-2" style={{color: "#44c8cf"}}><b><FormattedMessage id="Mano_de_Obra" defaultMessage="Mano de Obra"/></b></h2>
																				<table className="table">
																					<thead className="thead-fleet">
																						<tr>
																							{trabajaConManoDeObra
																								? showItems.map(function(field, idx) { return this.renderTableTheadItem(field, idx); }.bind(this))
																								: showTareas.map(function(field, idx) { return this.renderTableTheadTarea(field, idx); }.bind(this))
																							}
																						</tr>
																					</thead>
																					<tbody>
																						{trabajaConManoDeObra
																							? presupuesto.presupuestoRepuestos.filter(function(el) { return el.tipo === 'Mano De Obra'; }).map(function(element, idx) {
																								return (
																									<tr key={idx} style={(esRechazadoParcial && element.estado_recotizacion === ITEM_ESTADO_RECOTIZACION_RECHAZADO) ? {backgroundColor: '#f8d7da'} : undefined}>
																										{showItems.map(function(field) { return this.renderTableTbodyItem(element, field, idx, null, index, esRechazadoParcial); }.bind(this))}
																									</tr>
																								);
																							}.bind(this))
																							: presupuesto.presupuestoManoObras.map(function(element, idx) {
																								return (
																									<tr key={idx} style={(esRechazadoParcial && element.estado_recotizacion === ITEM_ESTADO_RECOTIZACION_RECHAZADO) ? {backgroundColor: '#f8d7da'} : undefined}>
																										{showTareas.map(function(field) { return this.renderTableTbodyTarea(element, field, idx, null, index, esRechazadoParcial); }.bind(this))}
																									</tr>
																								);
																							}.bind(this))
																						}
																						<tr>
																							<td className="align-middle" colSpan="2">
																								<b style={{fontSize: "17px"}}><FormattedMessage id="Presupuesto.Total_Mano_de_Obra" defaultMessage="Total Mano de Obra"/></b>
																							</td>
																							<td className="align-middle" colSpan={trabajaConManoDeObra ? showItems.length - 3 : showTareas.length - 3}>
																							</td>
																							<td className="align-middle">
																								<b style={{fontSize: "17px"}}>$ {this.formatMonto(presupuesto.manoDeObra)}</b>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</div>
																		</div>
																	</div>
																	<div className="p-2">
																		<div className="col-md-12">
																			<div className="col-md-12">
																				<h2 className="p-2" style={{color: "#44c8cf"}}><b><FormattedMessage id="Repuestos" defaultMessage="Repuestos"/></b></h2>
																				<table className="table">
																					<thead className="thead-fleet">
																						<tr>
																							{showItemsSinMecanico.map(function(field, idx) { return this.renderTableTheadItem(field, idx); }.bind(this))}
																						</tr>
																					</thead>
																					<tbody>
																						{(trabajaConManoDeObra
																							? presupuesto.presupuestoRepuestos.filter(function(el) { return el.tipo !== 'Mano De Obra'; })
																							: presupuesto.presupuestoRepuestos
																						).map(function(element, idx) {
																							return (
																								<tr key={idx} style={(esRechazadoParcial && element.estado_recotizacion === ITEM_ESTADO_RECOTIZACION_RECHAZADO) ? {backgroundColor: '#f8d7da'} : undefined}>
																									{showItemsSinMecanico.map(function(field) { return this.renderTableTbodyItem(element, field, idx, null, null, esRechazadoParcial); }.bind(this))}
																								</tr>
																							);
																						}.bind(this))}
																						<tr>
																							<td className="align-middle" colSpan="2">
																								<b style={{fontSize: "17px"}}><FormattedMessage id="Presupuesto.Total_Repuestos" defaultMessage="Total Repuestos"/></b>
																							</td>
																							<td className="align-middle" colSpan={showItemsSinMecanico.length - 3}>
																							</td>
																							<td className="align-middle">
																								<b style={{fontSize: "17px"}}>$ {this.formatMonto(presupuesto.repuestos)}</b>
																							</td>
																						</tr>
																					</tbody>
																				</table>
																			</div>
																		</div>
																	</div>
																</td>
															</tr>
															: null
														}
													{(this.state.presupuestos[index + 1] && this.state.presupuestos[index + 1].estado === PRESUPUESTO_ESTADO_RECHAZADO && this.state.presupuestos[index + 1].tipoRecotizacion === TIPO_RECOTIZACION_PARCIAL && (this.state.diffsAbiertos[presupuesto.id] || this.state.diffsLoading[presupuesto.id])) ? (
														this.renderDiffInline(presupuesto, 10, trabajaConManoDeObra)
													) : null}
													</React.Fragment>)
										})
									:
										<tr>
											<td colSpan="10" align={"center"}>
												<FormattedMessage
													id="No_hay_datos_disponibles"
													defaultMessage="No hay datos disponibles"
												/>
											</td>
										</tr>
									}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
			)
		} else {
			return null;
		}
  }
}

export default injectIntl(TicketVerPresupuestosDetallado);
